import { useEffect, useState } from "react";
import "./PaymentResultModal.css";
import ProfilingReport from "./ProfilingReport";
import { formatStopwatchElapsed } from "./usePaymentStopwatch";

function PaymentResultModal({ result, onClose }) {
  const [isProfilingOpen, setIsProfilingOpen] = useState(false);

  const profiling = result?.profiling;
  const profilingEvents = Array.isArray(profiling?.events)
    ? profiling.events
    : [];
  const hasProfiling = profilingEvents.length > 0;

  useEffect(() => {
    if (!result) {
      return undefined;
    }

    const previousOverflow = document.body.style.overflow;
    const closeOnEscape = (event) => {
      if (event.key === "Escape") {
        if (isProfilingOpen) {
          setIsProfilingOpen(false);
          return;
        }

        onClose();
      }
    };

    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", closeOnEscape);

    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener("keydown", closeOnEscape);
    };
  }, [isProfilingOpen, onClose, result]);

  useEffect(() => {
    if (result) {
      setIsProfilingOpen(false);
    }
  }, [result]);

  if (!result) {
    return null;
  }

  return (
    <>
      <div className="payment-result-modal-overlay" onClick={onClose}>
        <div
          className="deposit-history-panel deposit-history-data-panel payment-result-modal-dialog"
          role="dialog"
          aria-modal="true"
          aria-labelledby="payment-result-modal-title"
          onClick={(event) => event.stopPropagation()}
        >
          <div className="deposit-history-header payment-result-modal-header">
            <div>
              <h2 id="payment-result-modal-title">{result.title}</h2>
              <p>{result.message}</p>
            </div>
            <button
              type="button"
              className="history-close-button"
              onClick={onClose}
              aria-label="Close payment result modal"
            >
              <span className="close-icon" aria-hidden="true"></span>
            </button>
          </div>

          <div className="deposit-history-summary payment-result-summary">
            <div className="deposit-history-summary-row">
              <span>Status</span>
              <strong>{result.status}</strong>
            </div>
            <div className="deposit-history-summary-row">
              <span>Stopwatch</span>
              <strong>
                {formatStopwatchElapsed(result.elapsedMilliseconds)}
              </strong>
            </div>
            {(result.details || []).map(([label, value]) => (
              <div className="deposit-history-summary-row" key={label}>
                <span>{label}</span>
                <strong>{value}</strong>
              </div>
            ))}
          </div>

          <div className="deposit-history-footer payment-result-modal-actions">
            {hasProfiling && (
              <button
                type="button"
                className="secondary-action"
                onClick={() => setIsProfilingOpen(true)}
              >
                Profiling data
              </button>
            )}
            <button type="button" className="primary-action" onClick={onClose}>
              Close
            </button>
          </div>
        </div>
      </div>

      {isProfilingOpen && hasProfiling && (
        <div className="profiling-popup-layer">
          <ProfilingReport
            elapsedMilliseconds={result.elapsedMilliseconds}
            profiling={profiling}
            onClose={() => setIsProfilingOpen(false)}
          />
        </div>
      )}
    </>
  );
}

export default PaymentResultModal;
